// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".report-statement .msg-font {\n  display: inline-block;\n  margin-left: 75px;\n}\n.report-statement h2 {\n  margin-top: 20px;\n}\n.report-statement .ant-radio-wrapper {\n  margin-left: 25px;\n}\n.report-statement .fields-choice {\n  position: relative;\n  margin: 10px 20px;\n  padding: 20px;\n  background-color: #f0f0f0;\n}\n.report-statement .fields-choice .export-btn {\n  position: absolute;\n  right: 50px;\n  top: 15px;\n}", ""]);
// Exports
module.exports = exports;
